export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-02.db29720f.jpg";